module.exports = __webpack_public_path__ + "media/fonts/SFProText-Heavy-9ed6ede21a7dbb395626c26f3c5e020e.ttf";